import { parseJwt } from '../utils/jwtDecoder';
import { getItem } from '../utils/authStorage';
import { fetchWithAuthRetry, getAuthHeaders, ensureValidToken } from '../utils/helpers';

const emptySummary = {
  projectId: null,
  surveyId: null,
  totalCount: 0,
  categories: [],
  items: [],
};

/**
 * Fetch Site & Safety Observations summary for a project + survey.
 * GET /api/construction/projects/{numericId}/observations?surveyId=
 */
export async function fetchObservationsSummary(numericId, surveyId) {
  if (!numericId || !surveyId) return emptySummary;

  const endpoint =
    `/api/construction/projects/${numericId}/observations?surveyId=${encodeURIComponent(surveyId)}`;

  try {
    await ensureValidToken();
    const token = getItem('accessToken');
    const payload = token ? parseJwt(token) : null;
    const tenantId = payload?.tenant_id || '';

    const headers = {
      ...getAuthHeaders(),
      ...(tenantId ? { 'X-Tenant-Id': tenantId } : {}),
    };

    const response = await fetchWithAuthRetry(endpoint, { headers });
    if (response.ok) {
      const json = await response.json();
      return {
        projectId: json.projectId ?? numericId,
        surveyId: json.surveyId ?? surveyId,
        totalCount: Number(json.totalCount) || 0,
        categories: Array.isArray(json.categories) ? json.categories : [],
        items: Array.isArray(json.items) ? json.items : [],
      };
    }
    console.warn(`GET ${endpoint} → HTTP ${response.status}`);
  } catch (err) {
    console.error(`fetchObservationsSummary error (${endpoint}):`, err);
  }

  return emptySummary;
}
